import { useGuideline } from '../../context/GuidelineContext';
import { guidelineRegistry, CONTENT_REVIEWED } from '../../data/guidelines';
import './GuidelineHeader.css';

function GuidelineHeader() {
  const { guideline, guidelineId } = useGuideline();
  const nccnUrl = guidelineRegistry.find((g) => g.id === guidelineId)?.nccnUrl;

  return (
    <div className="guideline-header">
      <div className="guideline-header-info">
        <h1>{guideline.name}</h1>
        <span className="guideline-header-version">
          NCCN {guideline.nccnId} v{guideline.version}
        </span>
        <span className="guideline-header-reviewed">
          Content reviewed {CONTENT_REVIEWED}
        </span>
      </div>
      <div className="guideline-header-links">
        {nccnUrl && (
          <a
            href={nccnUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="nccn-link"
          >
            View on NCCN.org ↗
          </a>
        )}
        <a
          href="https://www.nccn.org/professionals/physician_gls/default.aspx"
          target="_blank"
          rel="noopener noreferrer"
          className="nccn-link secondary"
        >
          All NCCN Guidelines ↗
        </a>
      </div>
    </div>
  );
}

export default GuidelineHeader;
